@if ($company | async) {
<div id="standFooter" class="flex w-full items-center place-content-center bg-gray-400 opacity-0
        absolute left-0 h-[320px] bottom-[-230px] will-change-transform">
    <div class="container py-3">
      <div class="flex mb-2 text-xl">Belonging categories:</div>
      <div class="flex flex-col lg:grid lg:grid-cols-4 gap-4 w-full">
        @for (category of categories; track category._id) {
          <div class="w-full">
            <div class="flex items-center">
              <mat-icon svgIcon="halls:{{category.icon}}" class="!w-8 !h-8 mr-2"></mat-icon>
              <a [routerLink]="category | getCategoryUrl" class="no-underline text-2xl">{{category.shortName}}</a>
            </div>
            <ul class="hidden mt-2 h-[83px] lg:flex flex-wrap">
              @for (childCategory of category.childs; track childCategory._id; let last = $last) {
                <li>
                  @if (childCategory.level == 1) {
                    <a [routerLink]="childCategory | getCategoryUrl" class="no-underline text-sm hover:underline">{{childCategory.shortName}}</a>
                  }
                  @if (childCategory.level == 2) {
                    <span class="no-underline text-sm">{{childCategory.shortName}}</span>
                  }
                  @if (!last) {
                    <span class="text-sm font-bold"> &bull;&nbsp; </span>
                  }
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </div>
  </div>
}
